// eslint-disable-next-line filenames/match-regex
export const CHECK_OUT_LAYOUT = 'CheckoutLayout';
export const DEALS_LAYOUT = 'DealsLayout';
export const HEADER_FOOTER_LAYOUT = 'HeaderFooterLayout';
export const GIFT_LAYOUT = 'GiftLayout';
export const ACCOUNT_LAYOUT = 'AccountLayout';
export const LOGIN_LAYOUT = 'LoginLayout';
export const DELETE_LAYOUT = 'DeleteLayout';
